import React, { useState } from "react";
import * as AlfredoStyles from "../styles/components/AlfredoCentral";
import * as AlfredoInterface from "../interfaces";

interface AlfredoCentralIcon {
  imgSrc: string;
  onClick: () => void; // Ajuste aqui para especificar que é uma função que não retorna nada
}

const AlfredoCentral: React.FC<AlfredoCentralIcon> = ({ imgSrc, onClick }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragged, setDragged] = useState(false);

  let pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;

  const dragMouseDown = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setIsDragging(true);
    setDragged(false); // Reset drag state
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  };

  const elementDrag = (e: MouseEvent) => {
    e.preventDefault();
    setDragged(true); // Set drag state
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    setPosition((prevPosition) => ({
      x: prevPosition.x + pos1,
      y: prevPosition.y + pos2,
    }));
  };

  const closeDragElement = () => {
    setIsDragging(false);
    document.onmouseup = null;
    document.onmousemove = null;
  };

  const handleClick = (e: React.MouseEvent) => {
    if (!dragged) {
      onClick(); // Só dispara se não houve arraste
    }
  };

  return (
    <AlfredoStyles.AlfredoCentralButton
      onMouseDown={dragMouseDown}
      onClick={handleClick}
      style={{
        right: `${position.x}px`,
        bottom: `${position.y}px`,
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragging ? "grabbing" : "grab",
      }}
    >
      <img src={imgSrc} alt="Alfredo Central Button" />
    </AlfredoStyles.AlfredoCentralButton>
  );
};

export default AlfredoCentral;
